/**
 * Stable CSS class names for E2E — Retail DB page.
 */
export const RDB = {
    page: 'retail-db-page',
    loadingSection: 'retail-db-page__loading-section',
    breadcrumbSection: 'retail-db-page__breadcrumb-section',

    formStack: 'retail-db-page__form-stack',
    inputSalesId: 'retail-db-input--sales-id',
    inputWarehouse: 'retail-db-input--warehouse',

    actionsRow: 'retail-db-page__actions-row',
    deleteFromTransferButton: 'retail-db-input--button-delete-from-transfer',
    deleteFromMainButton: 'retail-db-input--button-delete-from-main',
} as const;

export const rdbCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

